module.exports = __webpack_public_path__ + "img/icon6.694e3fe6.png";